export type City = {
  name: string;
  region: string;
};

export const CITIES = [
  {
    name: 'Santiago',
    region: 'Región Metropolitana de Santiago',
  },
  {
    name: 'Valparaíso',
    region: 'Región de Valparaíso',
  },
  {
    name: 'Concepción',
    region: 'Región del Biobío',
  },
  {
    name: 'La Serena',
    region: 'Región de Coquimbo',
  },
  {
    name: 'Antofagasta',
    region: 'Región de Antofagasta',
  },
  {
    name: 'Temuco',
    region: 'Región de la Araucanía',
  },
  {
    name: 'Iquique',
    region: 'Región de Tarapacá',
  },
  {
    name: 'Rancagua',
    region: "Región del Libertador Gral. Bernardo O'Higgins",
  },
  {
    name: 'Puerto Montt',
    region: 'Región de Los Lagos',
  },
  {
    name: 'Talca',
    region: 'Región del Maule',
  },
  {
    name: 'Arica',
    region: 'Región de Arica y Parinacota',
  },
  {
    name: 'Chillán',
    region: 'Región de Ñuble',
  },
  {
    name: 'Los Ángeles',
    region: 'Región del Biobío',
  },
  {
    name: 'Calama',
    region: 'Región de Antofagasta',
  },
  {
    name: 'Colina',
    region: 'Región Metropolitana de Santiago',
  },
  {
    name: 'Quillota',
    region: 'Región de Valparaíso',
  },
  {
    name: 'Valdivia',
    region: 'Región de Los Ríos',
  },
  {
    name: 'Osorno',
    region: 'Región de Los Lagos',
  },
  {
    name: 'Copiapó',
    region: 'Región de Atacama',
  },
  {
    name: 'Curicó',
    region: 'Región del Maule',
  },
  {
    name: 'Melipilla',
    region: 'Región Metropolitana de Santiago',
  },
  {
    name: 'Punta Arenas',
    region: 'Región de Magallanes y de la Antártica Chilena',
  },
  {
    name: 'Lampa',
    region: 'Región Metropolitana de Santiago',
  },
  {
    name: 'San Antonio',
    region: 'Región de Valparaíso',
  },
  {
    name: 'Ovalle',
    region: 'Región de Coquimbo',
  },
  {
    name: 'Buin',
    region: 'Región Metropolitana de Santiago',
  },
  {
    name: 'Peñaflor',
    region: 'Región Metropolitana de Santiago',
  },
  {
    name: 'Linares',
    region: 'Región del Maule',
  },
  {
    name: 'Paine',
    region: 'Región Metropolitana de Santiago',
  },
  {
    name: 'Los Andes-Calle Larga',
    region: 'Región de Valparaíso',
  },
  {
    name: 'San Felipe',
    region: 'Región de Valparaíso',
  },
  {
    name: 'Talagante',
    region: 'Región Metropolitana de Santiago',
  },
  {
    name: 'San Fernando',
    region: "Región del Libertador Gral. Bernardo O'Higgins",
  },
  {
    name: 'Rengo',
    region: "Región del Libertador Gral. Bernardo O'Higgins",
  },
  {
    name: 'Coyhaique',
    region: 'Región Aisén del Gral. Carlos Ibáñez del Campo',
  },
  {
    name: 'Villarrica',
    region: 'Región de la Araucanía',
  },
  {
    name: 'Vallenar',
    region: 'Región de Atacama',
  },
  {
    name: 'San Carlos',
    region: 'Región de Ñuble',
  },
  {
    name: 'Angol',
    region: 'Región de la Araucanía',
  },
  {
    name: 'San Vicente',
    region: "Región del Libertador Gral. Bernardo O'Higgins",
  },
  {
    name: 'Constitución',
    region: 'Región del Maule',
  },
  {
    name: 'Limache',
    region: 'Región de Valparaíso',
  },
  {
    name: 'Cauquenes',
    region: 'Región del Maule',
  },
  {
    name: 'San Javier',
    region: 'Región del Maule',
  },
];
